import React from "react";
import HelpPage from "../shared/HelpPage.jsx";

// Charity dashboard Help. Keep this in step with the menu in
// layout/CharityLayout.jsx.

const SECTIONS = [
  {
    id: "start",
    title: "Getting started",
    where: "Claim Bar",
    body: [
      "Link your charity to each bar where you run gaming:",
      [
        "Search the bar's name or address and click Claim. Most bars are already in the app.",
        "The bar shows \"waiting for bar owner\" until the owner claims it too — that's normal. Your gaming info and events still show to customers right away.",
        "If it says the bar is linked to another charity and that's wrong, email hello@barfunfinder.com.",
      ],
      "By posting, you agree to the Partner Agreement: you're responsible for what you post.",
    ],
  },
  {
    id: "linked",
    title: "Linked Bars",
    where: "Linked Bars",
    body: [
      "Every bar your charity is connected to. Switch bars with the dropdown at the top of each page.",
      "Bar switched to a different charity? Click Unlink. Your gaming info and the events you posted for that bar are removed.",
    ],
  },
  {
    id: "events",
    title: "Events",
    where: "Events",
    body: [
      "Bingo, meat raffles, paddlewheels, poker and anything else customers can show up for.",
      [
        "\"Does this repeat?\": pick Every week for a standing night (like \"Bingo every Tuesday\") so you set it up once.",
        "Details shows under the title, e.g. \"$1,000 coverall\" or \"Doors open at 5:30\".",
        "Gambling events show your charity's name and license number next to the bar's name in the app.",
        "Check every kind that fits, like Bingo + Fundraiser. The choices match the bar's state.",
      ],
    ],
  },
  {
    id: "boost",
    title: "Boosting an event ($10)",
    where: "Events → Boost $10",
    body: [
      "Want a big crowd for a raffle or bingo night? A boost puts that event at the top of the Home screen with a ★ FEATURED tag, for customers up to 30 miles away, on the day it happens. Only 3 events per area can be boosted each day, first come, first served, so book early for big nights.",
      "Your first boost is free, so you can try it out. After that, $10 per event, paid by card. One-time, no subscription.",
    ],
  },
  {
    id: "gaming",
    title: "Gaming",
    where: "Gaming",
    body: [
      "The real gaming setup at each linked bar: games, pull-tab boxes, e-tabs, license number and hours. Customers see it on the bar's page and in the app's Pull-tabs tab.",
      "Keep it current — it's what customers rely on. If a bar has no charity account, the bar owner can fill this in instead.",
    ],
  },
  {
    id: "notifications",
    title: "Notifications",
    where: "Notifications",
    body: [
      "For right-now news: \"Bingo starts at 6 tonight!\" or \"Big pull-tab box just opened.\" It goes to the app's Alerts for people nearby. For anything on a schedule, use Events instead.",
      "Text your customers ($0.05 a text): on the same page, send a text to customers near the bar who turned on texts in the app. You see how many people it reaches and the cost before you send. Add money first; credit never expires and you're never charged for a text that didn't go through. One text a day per bar, between 9am and 8pm.",
    ],
  },
  {
    id: "pro",
    title: "Boost & Pro",
    where: "Boost & Pro",
    body: [
      "Your charity account is free during our launch — you don't pay to post events or keep gaming info current.",
      [
        "Boosts ($10 per event) are the way for a charity to get extra reach.",
        "Pro ($39/month) belongs to the bar and is paid by the bar owner. This page shows which of your bars are on Pro.",
      ],
    ],
  },
  {
    id: "advertise",
    title: "Advertise",
    where: "Advertise (opens a new tab)",
    body: [
      "A paid banner in the app's rotating sponsor spot, for your charity or any business. Different from a boost, which features one event.",
    ],
  },
  {
    id: "account",
    title: "Account & login",
    where: "Account",
    body: [
      [
        "Change your name, email or password here.",
        "Can't log in? Use Forgot password on the login page.",
        "Have both a charity and an owner account? Use a private/incognito window for the second one — one browser can only be logged in as one account at a time.",
      ],
    ],
  },
];

export default function Help() {
  return (
    <HelpPage
      intro="How every part of your charity dashboard works. Tap a topic to jump to it."
      sections={SECTIONS}
    />
  );
}
